import { StationDataTypes } from './station-data.types';

const INITIAL_STATE = {
  "stationDataEndpointUrl": "",
  "stationDataFeed": [],
  "filteredStationDataFeed": {
    "currentMapZoom": 0,
    "visibleMarkers": []
  }
};

const stationDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case StationDataTypes.SET_STATION_DATA_URL:
      return {
        ...state,
        "stationDataEndpointUrl": action.payload
      }

    case StationDataTypes.SET_STATION_DATA:
      return {
        ...state,
        "stationDataFeed": action.payload
      }

    case StationDataTypes.SET_FILTERED_STATION_DATA:
      return {
        ...state,
        "filteredStationDataFeed": action.payload
      }

    default:
     return state;
  }
};

export default stationDataReducer;